import { Inject } from '@odinjs/odin';
import { ChecklistAPI, ChecklistItem, FetchAPI, FilterAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnClear, OnClick, OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { ClearEvent, ClickEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import { ApplicationRoute, ModulesRoute } from '../../constants';
import ApprovalContext from '../../services/ApprovalService';
import BaseController from '../BaseController';

export enum SituationReason {
  RESPONSE_OPINION = 'RESPONSE_OPINION',
  REQUEST_OPINION = 'REQUEST_OPINION',
  WAITING_RESPONSE_OPINION = 'WAITING_RESPONSE_OPINION',
  URGENT = 'URGENT'
}

interface ApprovalItem {
  id: number;
  processId: number;
  releaseDate: string;
  situation: string;
  documentNumber: number;
  reason: SituationReason;
  totalApprovalValue: number;
  usernameOpinion: string;
  observation: string;
  originStock: string;
  targetStock: string;
}

@Controller({ fragment: 'approvals-list', component: 'main-layout' })
export default class ApprovalListController extends BaseController {

  internalNavigation: boolean;

  @Inject('fetch-list')
    fetchListApi: FetchAPI;

  @Inject('checklist-situations')
    checklistSituationsApi: ChecklistAPI;

  situations: ChecklistItem[] = [
    { key: 'A', label: MessageService.translate('approvals.filtered-list-approved-checkbox'), value: false },
    { key: 'B', label: MessageService.translate('approvals.filtered-list-settled-checkbox'), value: false },
    { key: 'E', label: MessageService.translate('approvals.filtered-list-forwarded-checkbox'), value: false },
    { key: 'P', label: MessageService.translate('approvals.filtered-list-pending-checkbox'), value: false },
    { key: 'R', label: MessageService.translate('approvals.filtered-list-disapproved-checkbox'), value: false },
  ];

  @OnMount({ target: 'main-layout' })
  onMountApprovalList(): void {
    applicationContext.clearNavigationStack();
  }

  @OnClear({ target: 'approvals-filter' })
  onUsersFilterClear(event: ClearEvent<unknown>): void {
    const filter = event.target as unknown as FilterAPI;
    filter.clear();
  }

  @OnMount({ target: 'checklist-situations' })
  onChecklistMount(): void {
    const { checklistSituationsApi } = this;
    checklistSituationsApi.setData(this.situations);
  }

  @OnMount({ target: 'approvals-filter' })
  onFilterMount(event: MountEvent): void {
    this.internalNavigation = false;
    const filter = event.target as FilterAPI;
    const initialFilter = { 'situations': [{ 'key': 'P', 'label': MessageService.translate('approvals.filtered-list-pending-checkbox'), 'value': false }] };
    const data = filter.restoreState(true) ? filter.getRecord() : initialFilter;
    filter.clear();
    filter.setData(data as Record<string, Value>);
  }

  @OnUnmount({ target: 'approvals-filter' })
  onFilterUnmount(event: MountEvent): void {
    const filter = event.target as FilterAPI;
    if (this.internalNavigation) {
      filter.persistState();
    } else {
      filter.clearPersistedState();
    }
  }

  @OnClick({ target: 'approval-list-card' })
  onCardDeckClick(event: ClickEvent): void {
    if (event) {
      const approvalItem = event.value as ApprovalItem;
      this.internalNavigation = true;

      ApprovalContext.set({ ...approvalItem, orderType: '', purchaseRequestNumber: '' });

      applicationContext.redirect(
        `${ModulesRoute.APPROVALS}${ApplicationRoute.APPROVAL_LIST}${ApplicationRoute.APPROVAL_ITEM}`,
        { id: approvalItem.id, processId: approvalItem.processId },
        { scrollToTop: true }
      );
    }
  }
}
